/**
 *@author chenli
 *@description 提醒周期设置
 */
import Component from '../../../../lib/component';
import template from './remind-cycle-settings.html';
import './remind-cycle-settings.scss'
import TimeControl from "../../../form/time-control/time-control";
import {AutoSelect} from '../../../util/autoSelect/autoSelect'
import dataTimeControl from "../../../form/datetime-control/datetime-control";

let config = {
    template: template,
    data: {
        selectDom:{}
    },
    actions: {
        init(){
            let formData = this.data.formData;
            let cycle = this.data.cycle;
            this.actions.initTime(formData);
            this.actions.initDateTime('提醒日期时间',formData);
            this.actions.initSelect(cycle,formData);
            this.actions.initRadio('每月提醒方式',formData);
        },
        initRadio(label,formData){
          let $el = this.el.find(`input[name=${label}]`);
          if(!$el.length) return;
          for(let i=0; i<$el.length; i++) {
              $el[i].value = formData[label]['group'][i]['value'];
              $el[i].dataset.label = formData[label]['group'][i]['label'];
          }
        },
        initTime(data){
            let $el = this.el.find('.remindTime')
            if(!$el.length) return;
            let label = '提醒时间';
            this.events.requiredChange(label,data[label].value);
            let changeValueRemind =(res=>{
                this.events.changeValue(label,res.value);
            })
            let timeControl = new TimeControl({data:{value: data[label].value || '',isAgGrid:true},events:{changeValue:changeValueRemind}});
            this.append(timeControl,$el);
        },
        initDateTime(label,formData){
            let $el = this.el.find('.remindTimeDate')
            if(!$el.length) return;
            this.events.requiredChange(label,formData[label].value);
            let changeValueStart =(res=>{
                this.events.changeValue(label,res.value || '');
            })
            let DataTimeControl = new dataTimeControl({data:{value: formData[label].value || '',isAgGrid:true},events:{changeValue:changeValueStart}});
            this.append(DataTimeControl,$el);
        },
        async initSelect(cycle,data){
            let _this = this;
            let selectData = []
            if(cycle.week || cycle.month) {
                let arr = []
                if(cycle.week) {
                    arr = ['提醒星期'];
                }else {
                    arr = ['提醒月份','月份按天提醒','月份按星期提醒','提醒星期'];
                }
                arr.forEach(item=>{
                    selectData =_this.actions.pickSelectData(data[item].options);
                    _this.actions.loadSelect(selectData,item,data[item].options);
                })
            }
        },
        pickSelectData(options){
            let arr = [];
            options.forEach(item=>{
                let obj = {};
                obj['id'] = item.value;
                obj['name'] = item.label;
                obj['py'] = item.py;
                arr.push(obj);
            })
            return arr;
        },
        pickChoosed(choosed,options){
            let arr = new Set();
            for (let j of choosed) {
                for (let i in options) {
                    if (j == options[i].value) {
                        let obj = {};
                        obj['id'] = options[i].value
                        obj['name'] = options[i].label;
                        obj['py'] = options[i].py;
                        arr.add(obj);
                    }
                }
            }
            return Array.from(arr);
        },
        loadSelect(list,label,options){
            let $el = this.el.find(`.form-group[data-label=${label}]>div`);
            if(!$el.length) return;
            let formData = this.data.formData;
            let _this = this;
            let choosed = this.actions.pickChoosed(formData[label].value,options)
            this.data.selectDom[label] = new AutoSelect({
                data:{
                    list: list,
                    choosed: choosed  || [],
                    multiSelect: true,
                    editable: true,
                    width:'240px',
                },
                events: {
                    onSelect:function(choosed) {
                        _this.events.changeChoosedData(label, choosed);
                    }
                }
            })
            this.append(this.data.selectDom[label],$el);
            this.events.requiredChange(label,choosed);
        }
    },
    binds: [],
    afterRender() {
        this.actions.init();
    },
    beforeDestory() {
        this.el.off();
    }
}
let CycleSettings = Component.extend(config)
export default CycleSettings




// WEBPACK FOOTER //
// app/components/customPage/remind-todo/remind-cycle-settings/remind-cycle-settings.js